import { useState, useEffect, useRef } from "react";

import fetchWrapper from "../../lib/apiCall";
import useAbortSignal from "../useAbortSignal";

export default function useAPICall(
  apiEndpoint,
  method = "GET",
  payload = null,
  additionalHeaders = {},
  enabled = true
) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const headersRef = useRef(additionalHeaders);
  const isMounted = useRef(false);

  const { controller } = useAbortSignal();

  useEffect(() => {
    if (!enabled) {
      setIsLoading(false);
      return;
    }

    async function fetchData() {
      if (!isMounted.current) {
        isMounted.current = true;

        let requestSignal;
        try {
          if (!controller.current) {
            controller.current = new AbortController();
          }
          requestSignal = controller.current?.signal;
          const result = await fetchWrapper.apiCall(
            apiEndpoint,
            method,
            payload,
            headersRef.current,
            requestSignal,
            true
          );

          setData(result);
        } catch (error) {
          if (!requestSignal?.aborted) setError(error);
        } finally {
          setIsLoading(false);
        }
      }
    }

    if (!error && enabled) {
      fetchData();
    }
  }, [apiEndpoint, method, payload, controller, enabled, error]);

  return { data, isLoading, error };
}
